const initialState = {
  network_data: {},
};

const performanceReducer = (state = initialState, action) => {
  switch (action.type) {
    case 'RESET_PERFORMANCE_REDUCER': {
      return initialState;
    }
    case 'SET_NETWORK_DATA': {
      return { ...state, network_data: action.data };
    }

    default:
      return state;
  }
};

export default performanceReducer;
